import createReactClass from 'create-react-class';
'use strict';

// Import Libraries
import React from 'react';
import ReactDOM from 'react-dom';

// Import JS Modules
import { builderDispatch, WebUI } from '../_utils/ui';
import parseQueryString from '../_utils/parse-query-string';

// -----------------------------------------------------------
//  Controller
// -----------------------------------------------------------
const Controller = createReactClass({
  displayName: 'Welcome back notification',
  getInitialState() {
    return {
      loaded: false
    };
  },
  UNSAFE_componentWillMount() {
    this.builderDispatchToken = builderDispatch.register(payload => {
      switch(payload.type) {
        case WebUI.LOGIN:
          if (payload.prodigal) {
            this.open();
          }
          break;
      }
    });
  },
  componentDidMount() {
    $(ReactDOM.findDOMNode(this)).modal({
      show: false
    });

    // show the modal if 'welcome-back' is in the querystring
    if (parseQueryString()['welcome-back']) {
      this.handleLogin();
    }
  },
  componentWillUnmount() {
    builderDispatch.unregister(this.builderDispatchToken);
  },
  open() {
    $(ReactDOM.findDOMNode(this)).modal('show');
  },
  render() {
    return (
      <div className="modal fade">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
                Great to see you again! Thank you for keeping your Photo Account active.
              </h4>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            </div>
            <div className="modal-body">
              In order to maintain the photos in your Photo Account, it is necessary to log in at least once every 12 months. Once an account becomes inactive for over 12 months, the stored images are deleted and no longer accessible.
            </div>
            <div className="modal-footer">
              <button type="button" data-dismiss="modal" className="btn btn-lg btn-primary">Ok</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
});

export default Controller;
